export default __webpack_public_path__ + "static/media/pictogramMail64.e37bdaf8.svg";